import React, { useCallback, useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { Chart } from 'primereact/chart'

import moment from 'moment'
import 'moment/locale/es'

import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { es } from 'date-fns/locale'
import './dashboard.css'

import { fetchConToken } from '../../helpers/fetch'
// import { lastMonth } from '../../helpers/general'

import { ReportByExecutives } from './budgets/ReportByExecutives'
import { ReportByAreas } from './budgets/ReportByAreas'
import { useDispatch, useSelector } from 'react-redux'
import { dashboardSetFiltersList } from '../../redux/actions/pptos'

moment.locale('es')

export const DashboardPptos = () => {

    const dispatch = useDispatch()
    const info = useSelector(state => state.general.info)
    const filtersDefaultDate = useSelector(state => state.ppto.dashboard_filters)

    const [loadingData, setLoadingData] = useState('')
    const [dataSetBar, setDataSetBar] = useState([])
    const [totals, setTotals] = useState(null)
    const [amounts, setAmounts] = useState(null)
    const [dataExecutives, setDataExecutives] = useState([])
    const [dataArea, setDataArea] = useState([])

    const [filters, setFilters] = useState({
        time: filtersDefaultDate?.time || 'year',
        dateFrom: filtersDefaultDate?.fecha_desde || new Date(),
        dateTo: filtersDefaultDate?.fecha_hasta || new Date(),
        id_moneda: info.local_id_moneda
    })

    const getData = useCallback(async () => {
        try {
            setLoadingData('Consultando datos...')
            const params = new URLSearchParams(filters).toString()
            const resp = await fetchConToken(`dashboard/budgets/?${params}`)
            const res = await resp.json()
            // console.log({ res })
            if (res.ok) {
                setLoadingData('Cargando datos...')
                setTotals(res.data[0].totals)
                setAmounts(res.data[0].amounts)
                setDataSetBar(res.data[0].dataMonthly)
                setDataArea(res.data[0].dataArea)
                setDataExecutives(res.data[0].dataExecutives)
                setLoadingData('')
            }
        } catch (error) {
            console.log(error)
            setLoadingData('')
        }
    }, [filters])

    const handleChangeDate = (newValue) => {
        setFilters({
            ...filters,
            dateFrom: newValue
        })
    }

    useEffect(() => {
        getData()
        dispatch(dashboardSetFiltersList({
            time: filters?.time,
            fecha_desde: filters?.dateFrom,
            fecha_hasta: filters?.dateTo
        }))
    }, [filters, dispatch, getData])

    return (
        <div className='p-container'>
            <h1 className='p-title ml-4 md:ml-0'>Dashboard Presupuestos por aprobar</h1>

            <div className='ml-4 md:ml-0'>
                <DateFilters
                    filters={filters}
                    setFilters={setFilters}
                    handleChangeDate={handleChangeDate}
                />
            </div>

            {loadingData === '' ?
                <>

                    <BoxTotals
                        filters={filters}
                        totals={totals}
                        amounts={amounts}
                    />

                    <BoxGrap
                        filters={filters}
                        dataSetBar={dataSetBar}
                    />

                    <div className='mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-2'>
                        <ReportByExecutives
                            data={dataExecutives}
                        />
                        <ReportByAreas
                            data={dataArea}
                        />
                    </div>
                </>
                :
                <div className='text-start mt-3'>
                    <div class="spinner-border p-color-primary" role="status">
                        <span class="visually-hidden" style={{ color: 'red' }}>Loading...</span>
                    </div>
                    <div>{loadingData}</div>
                </div>
            }


        </div >
    )
}

const DateFilters = ({ filters, setFilters, handleChangeDate }) => {
    return (
        <div className='d-flex mt-3'>
            {/* <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off"
                    checked={filters.time === 'year' && 'checked'}
                    onChange={() => setFilters({ ...filters, time: 'year' })}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio2" style={{ color: filters.time === 'year' ? '#8E24AA' : '#595759' }}>
                    Vista mensual (<span style={{ textTransform: 'capitalize' }}>Año</span>{' '}{moment(filters.dateFrom).format('YYYY')})
                </label>
            </div> */}
            <div className='p-text-date-year'>
                <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                    <DatePicker
                        views={['year']}
                        label="Año"
                        openTo="year"
                        name='dateFrom'
                        // minDate={new Date('2020-01-01')}
                        value={filters.dateFrom}
                        onChange={handleChangeDate}
                        renderInput={(params) => <TextField {...params} helperText={null} />}
                    />
                </LocalizationProvider>
            </div>
        </div>
    )

}

const BoxTotals = ({ totals, amounts }) => {

    // const { moneda, simbolo, separacion_miles, separacion_decimales } = useSelector(state => state.general.detail)

    const {
        local_moneda: moneda,
        local_simbolo: simbolo,
        local_separacion_miles: separacion_miles,
        local_separacion_decimales: separacion_decimales
    } = useSelector(state => state.general.info)


    return (
        <div className='m-2 md:m-0'>
            <div className="ms-1 mt-4">
                <div>
                    <h5>Resumen <label style={{ color: '#7d7a7d', fontSize: '16px', textTransform: 'capitalize' }}>({moneda})</label></h5>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 p-dash-cards mt-2">

                <div className="d-flex flex-column p-3 justify-content-top align-items-left">
                    <span className='d-flex align-items-center'>
                        <label className='tabla-punto-cliente-d'></label>
                        <span className='ms-1'>Generadas</span>
                    </span>
                    <span className="d-flex justify-content-between mt-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        <span>{totals?.total}</span>
                        <NumberFormat
                            value={parseFloat(amounts?.total || 0)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles || ","}
                            decimalSeparator={separacion_decimales || "."}
                            prefix={`${simbolo || "S/"} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </span>
                    {/* <GrowthRate rate={amounts?.total_growth_rate} /> */}
                </div>

                <div className="d-flex flex-column p-3 justify-content-top align-items-left">
                    <span className='d-flex align-items-center'>
                        <label className='tabla-punto-por-aprobar-d'></label>
                        <span className='ms-1'>Pendientes</span>
                    </span>
                    <span className="d-flex justify-content-between mt-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        <span>{totals?.por_aprobar}</span>
                        <NumberFormat
                            value={parseFloat(amounts?.por_aprobar) || 0}
                            displayType={'text'}
                            thousandSeparator={separacion_miles || ","}
                            decimalSeparator={separacion_decimales || "."}
                            prefix={`${simbolo || "S/"} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </span>
                    {/* <GrowthRate rate={amounts?.por_aprobar_growth_rate} /> */}
                </div>

                <div className="d-flex flex-column p-3 justify-content-top align-items-left">
                    <span className='d-flex align-items-center'>
                        <label className='tabla-punto-rentabilidad'></label>
                        <span className='ms-1'>Aprobadas</span>
                    </span>
                    <span className="d-flex justify-content-between mt-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        <span>{totals?.aprobados}</span>
                        <NumberFormat
                            value={parseFloat(amounts?.aprobado) || 0}
                            displayType={'text'}
                            thousandSeparator={separacion_miles || ","}
                            decimalSeparator={separacion_decimales || "."}
                            prefix={`${simbolo || "S/"} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </span>
                    {/* <GrowthRate rate={amounts?.aprobado_growth_rate} /> */}
                </div>

                <div className="d-flex flex-column p-3 justify-content-top align-items-left">
                    <span className='d-flex align-items-center'>
                        <label className='tabla-punto-por-anulados-d'></label>
                        <span className='ms-1'>Anuladas</span>
                    </span>
                    <span className="d-flex justify-content-between mt-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        <span>{totals?.anulados}</span>
                        <NumberFormat
                            value={parseFloat(amounts?.anulado) || 0}
                            displayType={'text'}
                            thousandSeparator={separacion_miles || ","}
                            decimalSeparator={separacion_decimales || "."}
                            prefix={`${simbolo || "S/"} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </span>
                    {/* <GrowthRate rate={amounts?.anulado_growth_rate} /> */}
                </div>

            </div>

        </div>
    )
}

const BoxGrap = ({ filters, dataSetBar }) => {

    return (
        <>
            <div className="row mt-4" style={{ backgroundColor: 'white', padding: '20px', borderRadius: '10px' }}>
                <div className="col d-flex justify-content-center">
                    <BarChart dataSet={dataSetBar} color={'#9ae3a1'} />
                </div>
            </div>
        </>
    )
}

const BarChart = ({ dataSet = [], color }) => {

    console.log('dataSet---', dataSet)
    const { aprobados, emitidos, por_aprobar, anulados } = dataSet

    const chartData = {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        datasets: [
            // {
            //     type: 'line',
            //     label: 'Aprobadas',
            //     borderColor: '#5CBF66',
            //     borderWidth: 2,
            //     fill: false,
            //     tension: 0.4,
            //     data: aprobados
            // },
            {
                type: 'bar',
                label: 'Generados',
                backgroundColor: '#b6cfff',
                data: emitidos,
                borderColor: 'white',
                borderWidth: 2
            },
            {
                type: 'bar',
                label: 'Pendientes',
                backgroundColor: 'orange',
                data: por_aprobar,
                borderColor: 'white',
                borderWidth: 2
            },
            {
                type: 'bar',
                label: 'Aprobadas',
                backgroundColor: '#5CBF66',
                data: aprobados,
                borderColor: 'white',
                borderWidth: 2
            },
            {
                type: 'bar',
                label: 'Anuladas',
                backgroundColor: 'lightgray',
                data: anulados
            }
        ]
    };

    const chartOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    }

    return (
        <Chart type="line" data={chartData} options={chartOptions} style={{ position: 'relative', width: '100%' }} />
    )

}

// const GrowthRate = ({ rate }) => {
//     return (
//         <>
//             <span style={{ fontSize: '13px', color: '#7d7a7d', marginTop: '5px' }}>
//                 {parseFloat(parseFloat(rate).toFixed(1)) || 0}
//                 <label style={{ fontSize: '12px' }}>%</label>
//                 {rate < 0 && <i className="bi bi-arrow-down" style={{ color: 'red' }}></i>}
//                 {rate > 0 && <i className="bi bi-arrow-up" style={{ color: 'green' }}></i>}
//                 {rate == 0 && <i className="bi bi-arrow-up" style={{ color: '#7d7a7d' }}></i>}
//             </span >
//             <span style={{ fontSize: '11px', color: '#7d7a7d' }}>Comparado mes anterior ({lastMonth})</span>
//         </>
//     )
// }